import { render, staticRenderFns } from "./AssessmentPage.vue?vue&type=template&id=45569c85&scoped=true"
import script from "./AssessmentPage.vue?vue&type=script&lang=js"
export * from "./AssessmentPage.vue?vue&type=script&lang=js"
import style0 from "./AssessmentPage.vue?vue&type=style&index=0&id=45569c85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45569c85",
  null
  
)

export default component.exports